import styled from "styled-components"
import TitleContainer from "../Shared/TitleContainer"
import TitleContent from "../Shared/TitleContent"
import Title from "../Shared/Title"
import Panel from "../Shared/Panel"

export const Intro = TitleContainer.extend`
  width: 718px;
  top: 144px;
  left: 24px;
  position: absolute;
`

export const IntroTitle = Title.extend`
  font-size: 72px;
  margin: 0.25rem 0;
`

export const IntroDescription = TitleContent.extend`
  font-size: 30px;
  color: #d8effe;
  margin-top: 0;
`

export const ContactPanels = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 788px;
  top: 232px;
  min-width: 1030px;
`

export const ContactPanelContainer = Panel.extend`
  background: #073853;
  width: 500px;
  position: relative;
  min-height: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & + & {
    margin-left: 30px;
  }
`

export const PanelIcon = styled.div`
  background: #25beae;
  display: flex;
  align-items: center;
  border-radius: 70px;
  height: 140px;
  width: 140px;
  flex-basis: 140px;
  position: absolute;
  top: -70px;
  left: 50%;
  margin-left: -70px;
  padding: 2rem;

  & > * {
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Kiosk/TellMeMoreView/UI.js